<app-auth-navbar></app-auth-navbar>

<main class="rtl">
    <div class="relative pt-16 pb-32 flex content-center items-center justify-center">
        <div class="bg-primary absolute top-0 w-full h-20 bg-center bg-cover">
            <span class="w-full h-full absolute" id="blackOverlay"></span>
        </div>
        <div class="container relative mx-auto pt-20">
            <div class="items-center flex flex-wrap">

                    <div class="w-full mx-auto px-2">

                        <!-- Blog Cover -->
                        <img [src]="blogModel.img?apiService.api+blogModel.img:'../../../../assets/img/article-foods.jpg'" alt="Blog Cover"
                            class="xl:w-8/12 xs:w-full mx-auto lg:h-[560px] md:h-[480px] rounded-lg" />

                        <!-- Blog Title -->

                            <h1 class="pb-4 pt-16 font-semibold text-4xl leading-normal">
                                {{blogModel.title}}
                              </h1>
                        <!-- Blog Info -->
                        <div class="w-[90%] mx-auto flex md:gap-4 xs:gap-2 items-center pt-4">
                            <div class="flex gap-2 items-center">
                                <h2 class="text-sm font-semibold dark:text-white"> {{blogModel.authorPost}} </h2>
                            </div>
                            <div class="dark:text-gray-500"> &nbsp; | &nbsp; </div>

                            <h3 class="text-sm font-semibold text-gray-600 dark:text-gray-400"> {{blogModel.createDate | shamsiDate}} </h3>

                        </div>

                        <!-- Blog -->
                        <div class="py-6">
                            <div class="md:w-[80%] xs:w-[90%] mx-auto pt-4">
                                <p class="mx-auto text-md dark:text-gray-300" [innerHTML]="blogModel.metaDescription">
                                    
                                </p>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        <!-- </div> -->
    </div>
</main>


<app-footer></app-footer>